<ng-container *ngFor="let item of reqForApprovalsData; let isLast = last">

        <nb-accordion [ngClass]="isLast? 'accordion-bottom':''" multi class="request-accordion"
            *ngIf="item?.totalTicketsCount != 0">

            <nb-accordion-item class="request-list-container" [expanded]="selectedCategory == item?.appName">
                <nb-accordion-item-header>
                    <div class="request-list" fxLayout="row">
                        <div class="request-count-circle" fxLayout="row" fxLayoutAlign="center center">
                            <div class="count">{{item?.totalTicketsCount}}</div>
                        </div>
                        <div class="request-title">
                            <span>{{item?.appName}}</span>
                        </div>

                    </div>
                </nb-accordion-item-header>
                <nb-accordion-item-body class="body-container">
                    <button class="approve" (click)="approveAll(item)" nbButton size="small" style="width: 100%;
            background-color: #23DCE1;
            color: #112868;
            border-color: #23DCE1;
            font-family: 'Figtree';
            font-weight: 700;
            text-transform: uppercase;
            margin-bottom: 12px;" *ngIf="item?.appName == 'Attendance Request'">
                        {{ 'Approve All' }}
                    </button>
                    <ltts-approval-details (backEvent)="handleChildEvent($event)"
                        (approveEvent)="approveRequest($event)" (declineEvent)="declineRequest($event, category)"
                        [reqData]="item"></ltts-approval-details>
                </nb-accordion-item-body>
            </nb-accordion-item>

        </nb-accordion>
    </ng-container>
